import Swiper, { Navigation, HashNavigation, Thumbs, Pagination, Autoplay, Controller } from 'swiper';
import { debounce } from 'throttle-debounce';

function init() {
  Swiper.use([Navigation, HashNavigation, Thumbs, Pagination, Autoplay, Controller]);
  var acfeLayoutSlug1 = 'post_slider';
  var acfeLayoutSlug2 = 'products';
  var acfeLayoutSlug3 = 'team_members';
  var $layouts = $('.layout-post-slider');
  var swiperNavSelector = '.swiper-nav';
  var swiperSelector = '.swiper';
  var swiperNavOptions = {
    slidesPerView: 'auto',
    loop: false,
    watchSlidesProgress: true, // required for thumbs
    freeMode: false, // set to true to allow non-sticky slide positions
    // spaceBetween: 50, // spaceBetween isn't swipable. using css padding on content within .swiper-slide instead.
    threshold: 50, // px
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  var swiperOptions = {
    autoHeight: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    slidesPerGroup: 1,
    // loop: true, // limited testing
    loop: false,
    speed: 800,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    threshold: 50, // px
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    hashNavigation: {
      watchState: true,
    },
    // view-source:https://swiperjs.com/demos/300-thumbs-gallery/core.html
    thumbs: {
      swiper: null,
      autoScrollOffset: 0, // hrm, 1 seems to work better on desktop. best with freeMode: false
    },
    breakpoints: {
      768: {
        thumbs: {
          swiper: null,
          autoScrollOffset: 1, // hrm, 1 seems to work better on desktop. best with freeMode: false
        },
      },
      // 992: {},
    },
  };

  var initSwiperForLayout = function($layout) {
    var $swiperDirections = $layout.find('.swiper-nav-directions');
    var $swiperNav = $layout.find(swiperNavSelector);
    var $swiper = $layout.find(swiperSelector);

    if($swiper.attr('data-autoplay')) {
      swiperOptions.autoplay = {};
      swiperOptions.autoplay.delay = parseFloat($swiper.attr('data-autoplay'));
      swiperOptions.autoplay.pauseOnMouseEnter = true;
    }

    var swiperNav = new Swiper($swiperNav.get(0), swiperNavOptions);
    swiperOptions.thumbs.swiper = swiperNav;
    var swiper = new Swiper($swiper.get(0), swiperOptions);

    // https://github.com/nolimits4web/Swiper/issues/1738#issuecomment-448840503
    // currently using "thumbs" instead of this approach
    // swiper.controller.control = swiperNav;
    // swiperNav.controller.control = swiper;

    var toggleSwiperDirections = function() {
      var slidesWidth = 0;
      var swiperWidth = $swiper.width();
      var swiperWidthAdjusted = swiperWidth + 22.5; // 22.5px (for the .p-4 on content within .swiper-slide)

      $swiperNav.find('.swiper-slide').each(function() {
        slidesWidth += $(this).width();
      });

      if(slidesWidth > swiperWidthAdjusted) {
        $swiperDirections.show();
      }
      else {
        $swiperDirections.hide();
      }
    }
    $(window).on('resize', debounce(100, toggleSwiperDirections));
    toggleSwiperDirections();
  };

  $layouts.each(function() {
    initSwiperForLayout($(this));
  });

  var scrollToTarget = function(selector, offset) {
    selector = (typeof selector !== 'undefined') ? selector : false;
    offset = (typeof offset !== 'undefined') ? offset : 0;
    if($('body').hasClass('admin-bar')) {
      offset += 32;
    }
    if(selector) {
      var $target = $(selector);
      if($target.length) {
        var top = $target.offset().top;
        $('html, body').animate({ scrollTop: top - offset }, 300);
        return;
      }
    }
  }

  if(window.location.hash) {
    var hash = window.location.hash.substr(1);
    if(hash === 'products' || $('.layout-products .swiper-slide[data-hash="' + hash + '"]').length) {
      scrollToTarget('.layout-products:first');
    }
  }

  window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=' + acfeLayoutSlug1, function(response, $flexible, $layout, ajaxData) {
    initSwiperForLayout($layout);
  });

  window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=' + acfeLayoutSlug2, function(response, $flexible, $layout, ajaxData) {
    initSwiperForLayout($layout);
  });

  window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=' + acfeLayoutSlug3, function(response, $flexible, $layout, ajaxData) {
    initSwiperForLayout($layout);
  });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/postSlider.js